/**
 * Générateur pseudo-aléatoire déterministe (mulberry32).
 *
 * Pourquoi pas Math.random : la simulation doit être reproductible à partir de
 * (état, delta). C'est ce qui permettra au serveur de rejouer un tick pour
 * valider un client, le jour où l'on voudra des classements ou un HDV
 * (GDD §13, « Autorité : le client, assumé »). Math.random rendrait ça
 * impossible sans réécrire le jeu. La graine vit donc dans l'état.
 */
export interface Alea {
  (): number
  graine: number
}

export function alea(seed: number): Alea {
  let a = seed >>> 0
  const f = () => {
    a = (a + 0x6d2b79f5) >>> 0
    let t = a
    t = Math.imul(t ^ (t >>> 15), t | 1)
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61)
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296
  }
  const g = f as Alea
  Object.defineProperty(g, "graine", { get: () => a })
  return g
}
